import ACTIONS from '@/storeActions';
import { v4 as uuidv4 } from 'uuid';
import { EventBus, EVENTS } from '@/libs/eventBus';
import i18n from '@/i18n';

class BusinessLogicObservation {
  constructor(vue) {
    this.vue = vue;
    this.state = vue.$store.state;
  }

  createDefaultObservation(participantId, exerciseId, page, penInkFormat = 'html') {
    let result = {
      observerTeamMemberId: this.vue.$store.state.user.userId,
      participantId,
      exerciseId,
      exerciseTransversal: false,
      name: `${i18n.t('ObservationPage.newTitle')} ${page}`,
      page,
      penInkFormat,
      html: '',
      modified: true,
      temporaryId: uuidv4(),
    };

    return result;
  }

  addNewNote(page, penInkFormat = 'html') {
    const participantId = this.state.currentParticipantId;
    const exerciseId = this.state.currentExerciseId;

    const newNote = this.createDefaultObservation(participantId, exerciseId, page, penInkFormat);
    this.vue.$store.dispatch(ACTIONS.PUSH_OBSERVATIONS, newNote);
    return newNote
  }

  createOrExtendNoteStack(noteCount) {
    const {
      currentParticipantId: participantId,
      currentExerciseId: exerciseId
    } = this.state
    const existingNotes = this.state.observations.filter(( obs ) => obs.participantId === participantId && obs.exerciseId === exerciseId);
    let newNotes = [];
    for (let n = 1; n <= noteCount; n++) {
      if (!existingNotes.some((x) => x.page === n)) newNotes.push(this.createDefaultObservation(participantId, exerciseId, n, 'html'))
    }
    this.state.observations.push(...newNotes)
  }

  addNewObservation(penInkFormat) {
    // const observerId = this.vue.$store.state.user.currentObserverId;
    const participantId = this.vue.$store.state.currentParticipantId;
    const exerciseId = this.vue.$store.state.currentExerciseId;
    let allObservations = this.vue.$store.state.observations.filter( (obs) => obs != null && obs.participantId === participantId && obs.exerciseId === exerciseId);

    console.log('all observations', allObservations);
    let page = 0;
    for (const i in allObservations) {
      if (i && allObservations[i]) {
        const obs = allObservations[i];
        console.log(obs);
        if (obs.page > page) {
          page = obs.page;
        }
      }
    }
    page++;

    const newObservation = this.createDefaultObservation(this.vue.$store.state.currentParticipantId, this.vue.$store.state.currentExerciseId, page, penInkFormat);
    console.log(newObservation);
    this.vue.$store.dispatch(ACTIONS.PUSH_OBSERVATIONS, newObservation);
    return newObservation;
  }

  loadAllObservations() {
    let promises = [];
    for (const participant of this.vue.$store.state.observerTimeTable) {
      for (const exercise of participant.exercises) {
        promises.push(this.loadObservation(participant.id, exercise.exerciseId));
      }
    }

    const result = new Promise((resolve, reject) => {

      Promise.all(promises).finally(() => resolve());

    });

    return result;
  }

  loadObservation(participantId, exerciseId) {
    const self = this;
    const observerId = this.vue.$store.state.user.userId;

    const params = {
      observerId,
      participantId,
      exerciseId,
    };

    const result = new Promise((resolve, reject) => {
      self.vue.$apiRequest.get('/Observations', params).then((data) => {
        // init with empty observation if none are retrieved
        let toAdd = data;
        if (!data || data.length < 1) {
          toAdd = [self.createDefaultObservation(participantId, exerciseId, 1)];
        }

        self.vue.$store.dispatch(ACTIONS.PUSH_OBSERVATIONS, toAdd);
        resolve(toAdd);
      }).catch((error) => {
        console.log('error', error);
        reject(error);
      });
    });

    return result;
  }

  syncSelectedObservations(created, updated, deleted) {
    console.log('CREATE OBSERVATIONS', created);
    console.log('UPDATE OBSERVATIONS', updated);
    console.log('DELETE OBSERVATIONS', deleted);

    let modifyStore = [];
    const self = this;

    const updateStoreAfterCreate = (result) => {
      if (result) {
        console.log('CREATED ITEM', result);
        self.vue.$store.dispatch(ACTIONS.UPDATE_OBSERVATIONS, { temporaryId: result.temporaryId, id: result.id, modified: false });
      }
    };

    const updateStoreAfterUpdate = (result) => {
      if (result) {
        console.log('UPDATED ITEM', result);
        self.vue.$store.dispatch(ACTIONS.UPDATE_OBSERVATIONS, { id: result.id, modified: false });
      }
    };

    const removeFromStoreById = (id) => {
      if (id) {
        console.log('REMOVE OBSERVATION ID', id);
        self.vue.$store.dispatch(ACTIONS.REMOVE_OBSERVATION, { id });
      }
    };

    created.reduce( (previousPromise, nextObservation) => previousPromise.then((result) => {
      updateStoreAfterCreate(result);

      console.log('SYNC CREATE next observation', nextObservation.temporaryId);
      return this.vue.$apiRequest.post('/observations', nextObservation);
    }).catch( (error) => console.log('CREATE ERROR', error) ), Promise.resolve())
      .then((result) => updateStoreAfterCreate(result));

    updated.reduce( (previousPromise, nextObservation) => previousPromise.then((result) => {
      updateStoreAfterUpdate(result);

      console.log('SYNC UPDATE next observation', nextObservation.id);
      return this.vue.$apiRequest.put('/observations', nextObservation);
    }), Promise.resolve())
      .then((result) => updateStoreAfterUpdate(result))
      .catch( (error) => console.log('CREATE ERROR', error) );

    deleted.reduce( (previousPromise, nextObservation) => previousPromise.then((result) => {
      removeFromStoreById(result);

      console.log('SYNC DELETE next observation', nextObservation.id);
      return this.vue.$apiRequest.delete(`/observations/${nextObservation.id}`);
    }).catch( (error) => console.log('CREATE ERROR', error) ), Promise.resolve())
      .then((result) => removeFromStoreById(result));

  }

  syncAllObservations() {
    console.log('SYNC ALL OBSERVATIONS');
    if (!this.vue.$store.getters.syncFromAppToCockpitAllowed || this.vue.$store.getters.isGuestObserver) {
    //if (this.vue.$store?.state?.runInfo?.runInformation?.syncFromAppToCockpitAllowed === false) {
      console.log('Skipped sync - not allowed currently');
      return;
    }

    // do not send anything to server currently
    // todo check if the syncAll is actually a valid running operation as it is now
    //  -> seems to be causing issues with duplication
    //  -> creation with immediate observation / exercise switch seems to cause duplication too

    const createdObservations = this.vue.$store.state.observations.filter( (obs) => obs.modified === true && obs.id == null );
    const updatedObservations = this.vue.$store.state.observations.filter( (obs) => obs.modified === true && obs.id != null);
    const deletedObservations = this.vue.$store.state.observations.filter( (obs) => obs.deleted === true );
    this.syncSelectedObservations(createdObservations, updatedObservations, deletedObservations);
  }

  deleteObservation(observation) {
    if (!this.vue.$store.getters.syncFromAppToCockpitAllowed || this.vue.$store.getters.isGuestObserver) {
    //if (this.vue.$store?.state?.runInfo?.runInformation?.syncFromAppToCockpitAllowed === false) {
      console.log('Skipped sync - not allowed currently');
      return;
    }

    const self = this;

    if (observation.id) {

      let update = {
        id: observation.id,
        deleted: true,
      };

      this.vue.$store.dispatch(ACTIONS.UPDATE_OBSERVATIONS, update); //save updates to store
      //EventBus.$emit(EVENTS.RESTART_SYNC); // todo: interval for sync service
      // do not actually go against api to delete the observation -> let that one be handled by syncService
      /*this.vue.$apiRequest.delete(`/observations/${observation.id}`)
        .then((data) => {
          // Remove from store
          self.vue.$store.dispatch(ACTIONS.REMOVE_OBSERVATION, observation);
        })
        .catch((error) => {
          console.log('Observation error', error);
          let errorMessage = null;
          switch (error.status) {
            default:
              errorMessage = 'Errors.unknown';
          }
          self.vue.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: self.vue.$i18n.t(errorMessage), color: 'error' });
          EventBus.$emit(EVENTS.RESTART_SYNC); // todo: interval for sync service
        })
        .finally(() => {
        });*/
    } else {
      self.vue.$store.dispatch(ACTIONS.REMOVE_OBSERVATION, observation);
    }

  }

  /**
   * @typedef {Object} InterviewQuestion
   * @param {number} id
   * @param {number} interviewCompetencyId
   * @param {string} text
   * @param {number} rating
   * @param {string} freeText
   * @param {boolean} hasFreeText
   * @param {number} orderIndex
   * @param {boolean} hasNote
   * @param {boolean} isScored
   * @param {number} interviewQuestionType
   */
  saveQuestion(objToSave) {
    this.vue.$apiRequest.put(`/interviews/byCompetencyId/${objToSave.interviewCompetencyId}`, objToSave).then((result) => {}).catch((err) => console.error(err));
  }

  saveCompetency(objToSave) {
    this.vue.$apiRequest.put(`/interviews/byInterviewId/${objToSave.interviewId}`, objToSave).then((result) => {}).catch((err) => console.error(err));
  }
}

export default BusinessLogicObservation;
